import { NotImplementedError } from "../../../../../errors";
import { parseDateFilter } from "../../../../../models/looker/modules/inventory";
import { PromiseHandler } from "../../../../../handlers";
import { FILTER_OPTIONS_CHANNEL_QUERY } from "../query";
export default class LookerInventoryChannelFilter extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "looker-inventory-channel-filter");
    }
    async findItems(filters) {
        const dateFilter = filters.where?.find((filter) => filter.field === "dates");
        if (!dateFilter) {
            throw new Error("Dates filter is required");
        }
        // Publisher filter is required
        const publisherFilter = filters.where?.find((filter) => filter.field === "publisherIds");
        if (!publisherFilter ||
            !Array.isArray(publisherFilter.value) ||
            publisherFilter.value.length === 0) {
            throw new Error("Publisher filter is required");
        }
        const parsedDateFilter = parseDateFilter(dateFilter);
        const queryBody = {
            ...FILTER_OPTIONS_CHANNEL_QUERY,
            filters: {
                "billable_agg.filter_date_nyc": parsedDateFilter,
                "billable_agg.publisher_id": publisherFilter.value.join(",")
            }
        };
        // Add advertiser filter if provided
        const advertiserFilter = filters.where?.find((filter) => filter.field === "advertiserIds");
        if (advertiserFilter) {
            queryBody.filters["conversion_meta_inst.advertiser__id"] = advertiserFilter.value.join(",");
        }
        // Add campaign filter if provided
        const campaignFilter = filters.where?.find((filter) => filter.field === "campaignIds");
        if (campaignFilter) {
            queryBody.filters["conversion_meta_inst.campaign__id"] = campaignFilter.value.join(",");
        }
        // Add bundle filter if provided
        const bundleFilter = filters.where?.find((filter) => filter.field === "bundle");
        if (bundleFilter) {
            queryBody.filters["billable_agg.bundle"] = bundleFilter.value.join(",");
        }
        const hashKey = await this.sdk.looker.query.hashQuery(queryBody);
        return this.cache.promise(hashKey, () => this.sdk.looker.query
            .run(queryBody)
            .then(({ data, queryMeta }) => [
            {
                data: this.formatChannelResponse(data),
                queryMeta
            }
        ])
            .catch((e) => {
            console.error(e);
            throw new Error("Failed to fetch inventory dashboard channel filter options");
        }));
    }
    formatChannelResponse(data) {
        // Deduplicate channels
        const channels = new Set();
        data.forEach((channel) => {
            if (channel["billable_agg.channel"]) {
                channels.add(channel["billable_agg.channel"]);
            }
        });
        return Array.from(channels)
            .sort()
            .map((channel) => ({
            id: channel,
            name: channel
        }));
    }
    async saveItem() {
        throw new NotImplementedError("saveItem");
    }
    async deleteItem() {
        throw new NotImplementedError("deleteItem");
    }
}
//# sourceMappingURL=Channel.js.map